import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

interface MobileBackContextValue {
  onBack: (() => void) | null
  useHomeIcon: boolean
  setBack: (handler: (() => void) | null, opts?: { useHomeIcon?: boolean }) => void
}

const MobileBackContext = createContext<MobileBackContextValue | null>(null)

export const MobileBackProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [state, setState] = useState<{
    onBack: (() => void) | null
    useHomeIcon: boolean
  }>({ onBack: null, useHomeIcon: false })

  const setBack = useCallback<MobileBackContextValue['setBack']>(
    (handler, opts) => {
      setState({
        onBack: handler,
        useHomeIcon: Boolean(opts?.useHomeIcon),
      })
    },
    [],
  )

  const value = useMemo<MobileBackContextValue>(
    () => ({ onBack: state.onBack, useHomeIcon: state.useHomeIcon, setBack }),
    [state, setBack],
  )

  return (
    <MobileBackContext.Provider value={value}>
      {children}
    </MobileBackContext.Provider>
  )
}

export const useMobileBack = () => {
  const ctx = useContext(MobileBackContext)
  if (!ctx) {
    return {
      onBack: null,
      useHomeIcon: false,
      setBack: () => {},
    } as MobileBackContextValue
  }
  return ctx
}
